import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class DesksLandingPageRoute extends Route {
  @service state;
  @service router;
  @service featureConfig;
  @service abilities;
  @service featureFlags;

  beforeModel() {
    if (this.abilities.cannot('visit-landing desks')) {
      this.router.transitionTo('unauthorized');
    }

    if (this.abilities.can('use generic resource')) {
      this.router.transitionTo('resources.resource-type.index', 1);
    }
  }

  model() {
    return this.modelFor('desks');
  }

  redirect({ floors }) {
    const { currentLocationEnabledDesks } = this.state;
    const canAccessDesksApplication = !!this.state.features?.canAccessDesksApplication;
    const hasDesksAccess = this.featureConfig.isEnabled('desks') || canAccessDesksApplication;

    if (
      hasDesksAccess &&
      currentLocationEnabledDesks &&
      !floors.length &&
      this.featureConfig.isEnabled('desks.accessDesksTab')
    ) {
      return this.router.transitionTo('desks.get-started');
    } else if (
      hasDesksAccess &&
      currentLocationEnabledDesks &&
      floors.length &&
      this.featureConfig.isEnabled('desks.accessDesksTab')
    ) {
      return this.router.transitionTo('desks.index');
    }
  }
}
